module.exports = __webpack_public_path__ + "img/setting_incoming_inventory.bac88bb4.svg";